import React, { Component } from "react";
import logo from "./logo.svg";
import "./App.css";
import NavBar from "./components/navbar";
import Counters from "./components/counters";

class App extends Component {
  state = {
    counters: [
      { id: 1, value: 0 },
      { id: 2, value: 0 },
      { id: 3, value: 0 },
      { id: 4, value: 0 },
    ],
    total: 4,
  };

  render() {
    return (
      <React.Fragment>
        <NavBar
          getTotal={this.state.counters.reduce((a, b) => a + b.value, 0)}
          totalItems={this.state.counters.filter((c) => c.value > 0).length}
        ></NavBar>
        <main className="container">
          <Counters
            counters={this.state.counters}
            onNew={this.handleNewProduct}
            onReset={this.resetAll}
            onClear={this.handleClear}
            onIncrement={this.handleIncrement}
            onRemove={this.handleRemove}
            onDelete={this.handleDelete}
          ></Counters>
        </main>
      </React.Fragment>
    );
  }

  //handling the increment event
  handleIncrement = (counter) => {
    const counters = this.state.counters.map((c) => {
      c.value = counter.id === c.id ? c.value + 1 : c.value;
      return c;
    });
    this.setState({ counters: counters });
  };

  //handling the remove event
  handleRemove = (counter) => {
    const counters = this.state.counters.map((c) => {
      if (c.value <= 0) return c;
      c.value = counter.id === c.id ? c.value - 1 : c.value;
      return c;
    });
    this.setState({ counters: counters });
  };

  //handling the delete event
  handleDelete = (counterId) => {
    const counters = this.state.counters.filter((c) => c.id !== counterId);
    this.setState({ counters: counters });
    console.log(this.state.counters);
  };

  //handling reset button
  resetAll = () => {
    console.log("Reset button called!");
    const counters = this.state.counters.map((c) => {
      c.value = 0;
      return c;
    });
    console.log(counters);
    this.setState({ counters: counters });
  };

  //Adding a new product
  handleNewProduct = () => {
    let accumulator = this.state.total + 1;
    this.setState({ total: accumulator });
    console.log("new product was added! ", accumulator);
    let counters = this.state.counters;
    counters.push({ id: accumulator, value: 0 });
    this.setState({ counters: counters });
  };

  //Clearing the page
  handleClear = () => {
    const counters = [];
    this.setState({ counters: counters });
  };
}

export default App;
